import React, { useState, useEffect } from "react";
import { Loader, Pagination } from "semantic-ui-react";
import { map, size } from "lodash";
import { Newsletter } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { EmailItem } from "../EmailItem";
import "./ListEmails.scss";

const newsletterController = new Newsletter();

export function ListEmails() {
  const { accessToken } = useAuth();

  const [emails, setEmails] = useState(null);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);

  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await newsletterController.getEmails(
          accessToken,
          page,
        );
        //console.log("Emails cargados para la página:", page, response.docs); // Log de los emails de la página actual
        setEmails(response.docs);

        setPagination({
          total: response.totalDocs,
          limit: response.limit,
          page: response.page,
          pages: response.totalPages,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }, [accessToken, page, reload]);

  const changePage = (_, data) => {
    setPage(data.activePage);
  };

  if (!emails) return <Loader active inline="centered" />;

  if (size(emails) === 0) {
    return <h2>No emails found</h2>;
  }

  return (
    <div className="list-emails">
      {map(emails, (email) => (
        // console.log(email.email),
        <EmailItem key={email._id} email={email} onReload={onReload} />
      ))}
      <div className="list-emails__pagination">
        <Pagination
          defaultActivePage={page}
          totalPages={pagination.pages}
          ellipsisItem={false}
          firstItem={null}
          lastItem={null}
          onPageChange={changePage}
        />
      </div>
    </div>
  );
}
